/**
 @ngdoc directive
 @name hiddenModelSync

 @description
 Keeps hidden inputs and their AngularJS ngModel state in sync when a jQuery document event is emitted.
 This is useful for non-Angular widgets, such as element-loader address components, that update
 hidden form fields outside the AngularJS input pipeline.

 @usage
 <input
 type="hidden"
 ng-model="formModel.defaultAddress.line_1"
 hidden-model-sync="defaultAddress:changed"
 hidden-model-sync-field="line_1"
 >
 */
(function () {
  "use strict";

  var hiddenModelSync = function () {
    return {
      restrict: "A",
      require: "ngModel",
      scope: false,
      link: function (scope, element, attrs, ngModelCtrl) {
        // jQuery document event to listen for. Example: defaultAddress:changed
        var eventName = attrs.hiddenModelSync || "hidden:modelSync";

        // Optional field to pull from an object payload. Example: line_1, town, country
        var fieldPath = attrs.hiddenModelSyncField || "";

        // Optional DOM target id to keep in sync alongside ngModel.
        // Defaults to the current element's id.
        var targetId = attrs.hiddenModelSyncTarget || attrs.id;

        function readByPath(obj, path) {
          if (!obj || !path) return undefined;

          var parts = path.split(".");
          var current = obj;

          for (var i = 0; i < parts.length; i++) {
            if (current == null) return undefined;
            current = current[parts[i]];
          }

          return current;
        }

        function resolveValue(payload) {
          // If a field is configured, pull that specific value from the event payload.
          if (fieldPath) return readByPath(payload, fieldPath);

          // Otherwise allow primitive payloads to be used directly.
          return payload;
        }

        function normaliseValue(value) {
          // Ensure we always return a string suitable for use in a hidden input and ngModel.
          if (value == null) {
            return "";
          }

          var valueType = typeof value;

          // Leave strings as-is.
          if (valueType === "string") {
            return value;
          }

          // Normalise numbers and booleans to their string representation.
          if (valueType === "number" || valueType === "boolean") {
            return String(value);
          }

          // For objects/arrays, use JSON so the stored value is deterministic,
          // instead of "[object Object]".
          if (valueType === "object") {
            try {
              return JSON.stringify(value);
            } catch (e) {
              // If JSON serialisation fails, fall back to an empty string to avoid
              // leaking an unsafe or unexpected representation into the DOM.
              return "";
            }
          }

          // Fallback for other exotic types (e.g. symbols, functions).
          return String(value);
        }

        function syncDomValue(value) {
          if (!targetId) return;
          $("#" + targetId).val(value);
        }

        function syncNgModel(value) {
          ngModelCtrl.$setViewValue(value);
          ngModelCtrl.$render();
          ngModelCtrl.$validate();
        }

        function handleEvent(_event, payload) {
          var value = normaliseValue(resolveValue(payload));

          scope.$evalAsync(function () {
            syncDomValue(value);
            syncNgModel(value);
          });
        }

        // Listen to the same jQuery document event used by the Angular 2+ address element.
        $(document).on(eventName, handleEvent);

        // Clean up the document listener when Angular destroys this input.
        scope.$on("$destroy", function () {
          $(document).off(eventName, handleEvent);
        });
      },
    };
  };

  hiddenModelSync.$inject = [];
  angular.module("app").directive("hiddenModelSync", hiddenModelSync);
})();

